export class AppsDetails {
    'apps';
    'isOverridden';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apps",
            "baseName": "apps",
            "type": "Array<App>",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AppsDetails.attributeTypeMap;
    }
    constructor() {
    }
}
